/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { Form, Input, Row } from "antd";
import { TypeCommon } from "models/common";
import { ReactElement } from "react";
import "./index.css";

const BaseInput = ({
  name,
  label,
  height,
  disabled = false,
  value,
  type,
  required = false,
  rule = [],
  className = "",
  suffix,
  placeholder,
  restField,
  key,
  readOnly = false,
  onKeyDown,
  maxLength,
  isRequired = false,
  showCount = false,
  addonBefore,
  isValueExist,
  helpText,
}: {
  name: TypeCommon;
  label?: TypeCommon;
  height?: number;
  disabled?: boolean;
  value?: TypeCommon;
  type?: string;
  required?: boolean;
  rule?: TypeCommon;
  className?: string;
  suffix?: TypeCommon;
  placeholder?: string;
  restField?: TypeCommon;
  key?: string;
  readOnly?: boolean;
  onKeyDown?: TypeCommon;
  maxLength?: number;
  isRequired?: boolean;
  showCount?: boolean;
  addonBefore?: string;
  isValueExist?: boolean;
  helpText?: string;
}): ReactElement => {
  return (
    <Form.Item
      key={key}
      name={name}
      id={name}
      {...restField}
      required={required}
      validateStatus={isValueExist ? "error" : undefined}
      help={isValueExist ? helpText : undefined}
      label={
        <Row className={`${label ? "text-[14px] " : "!hidden"}`}>
          {label}
          {isRequired && <Row className="text-red-500 ml-1">＊</Row>}
        </Row>
      }
      rules={rule}
      className={className}
    >
      {type === "password" ? (
        <Input.Password
          style={{ height: height ? `${height}px` : "50px" }}
          className="!rounded-[10px] !outline-0"
          autoComplete="off"
          maxLength={maxLength}
          onKeyDown={(e): void => {
            if (onKeyDown) {
              onKeyDown(e);
            }
          }}
        />
      ) : (
        <Input
          type={type}
          value={value}
          disabled={disabled}
          id={name}
          addonBefore={addonBefore}
          showCount={showCount}
          style={{ height: height ? `${height}px` : "30px" }}
          className="!rounded-[10px] !outline-0"
          suffix={suffix}
          onKeyDown={(e): void => {
            if (onKeyDown) {
              onKeyDown(e);
            }
          }}
          placeholder={placeholder ?? ""}
          readOnly={readOnly}
          maxLength={maxLength}
        />
      )}
    </Form.Item>
  );
};

export default BaseInput;
